<mat-grid-list cols="15" rowHeight="60px" style="justify-content: flex-end">
  <mat-grid-tile [colspan]="6" class="left">
    <div class="mt-10" style="margin-right: auto;">
      <span class="stat-titlenew"
        >{{ "adt.CurrentERPatient" | translate }} :</span
      >
      <span class="patient-countnew">{{ totalAdmission }}</span
      >&nbsp;&nbsp;&nbsp;
      
      <span class="patient-countnew"></span
      >&nbsp;&nbsp;&nbsp;
    </div>
  </mat-grid-tile>
  <mat-grid-tile [colspan]="6" class="right">
    <mat-radio-group
      [(ngModel)]="admissionSort"
      (change)="admissionSortMethod($event)"
      class="radio"
      data-automation-attribute="radiogrp-patient-type"
    >
      <mat-radio-button [value]="'All'" data-automation-attribute="radio-new">
    {{ "adt.allPatients" | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="'ADMITTED'" data-automation-attribute="radio-current">
        {{ "adt.currentpatient" | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="'CANCELLED'" data-automation-attribute="radio-existing">
         {{ "adt.canceledvisit" | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </mat-grid-tile>

  <mat-grid-tile [colspan]="3">
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        [(ngModel)]="BarCode"
        placeholder="{{ 'labPage.Barcode' | translate }}"
        (focusout)="applyFilter(BarCode)"
      />
    </mat-form-field>
    <mat-icon style="color: #389683" 
      matTooltip="Scan QR/Barcode"
      (click)="openBarcodeScanDialog()"
    >
      center_focus_weak
    </mat-icon>
  </mat-grid-tile>
</mat-grid-list>
<mat-drawer-container class="example-container">
  <mat-drawer-content>
    <div class="table-height"> 
      <table
        mat-table
        [dataSource]="dataSource"
       
      >
      <ng-container matColumnDef="EncounterNumber">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{"common.visitNo" | translate}}
        </th>
        <td mat-cell class="col-nowrap" *matCellDef="let element" class="no-padding">
          <div>
            <span class="encounter-number">{{ element.admissionNo }}</span><br>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Gender/Age">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{ "adt.genderAge" | translate }}
        </th>
        <td mat-cell *matCellDef="let element"> 
        <!-- [ngClass]="{'vip-background': element.isVip}"> -->
          <div class="cell-content">
            <img src="./assets/images/{{ element.patientImage }}" alt="image" class="patient-image" />
            <div class="patient-details">
              <strong class="age-font">{{ element.PatientAge }}</strong>
              <span>{{ element.age }}</span>
            </div>
          </div>
        </td>            
      </ng-container>

      <ng-container matColumnDef="MRN">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{"AppointmentListPage.patient"| translate}}
        </th>
        <td mat-cell class="col-nowrap" *matCellDef="let element" >
        <!-- [ngClass]="{
          'vip-background': element.isVip,
          'long-name': element.patientName.length > 25
        }"
        > -->
          <div>
            <div class="name-div">
            <strong class="name-container"><span *ngIf="showPatientPrefix">{{element.displayTitle}}</span> {{ element.patientNameLangBase || element.patientName }}</strong>
            <div  *ngIf="element.isVip">
              <img src="./assets/images/vip-icon.png" height="20px"/>
             </div>
            <br>
            </div>
            <span class="doctor-name">{{ element.mrn }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="DepartmentName">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{"adt.Speciality" | translate}}
        </th>
        <td mat-cell class="col-nowrap" *matCellDef="let element">
        <!-- [ngClass]="{
          'vip-background': element.isVip,
          'doctor-long-name': element.admittingDoc.length > 25
        }"> -->
          <div>
            <strong class="age-font">{{ element.admittingDept }}</strong><br>
            <div class="name-div">
            <span class="name-contain">{{ element.admittingDoc }}</span>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="patientCategory">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{"AppointmentListPage.patientCategory" | translate}}
          </th>
          <td mat-cell  *matCellDef="let element">
            <strong class="Age-font">{{ element.patientCategory}}</strong>
          </td>
        </ng-container>
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{"billing.location" | translate}}
        </th>
        <td mat-cell  *matCellDef="let element">
          <!-- [ngClass]="{
            'vip-background': element.isVip
          }">  -->
          <span class="encounter-number">{{ element.Clinic }}</span><br>
          <span class="encounter-token">{{ element.los }}</span>
          <!-- <span class="encounter-token">{{ element.EncounterToken }}</span> -->
      </td>
      </ng-container>

      <ng-container matColumnDef="VisitDate">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{ "billing.visitDetails"| translate}}
        </th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          <strong  class="age-font">{{ element.doa}}</strong><br>
          <span>{{ element.time  }}</span>
        </td>
      </ng-container>

      
      <ng-container matColumnDef="cancelled">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          Cancel / Discharge Date
        </th>
        <td mat-cell class="col-norwap" *matCellDef="let element" class="{{ element.Color }}">
          <strong 
          class="date-font" 
          [ngStyle]="{'color': element.cancelDate ? '#f25a5a' : 'inherit'}">
          {{ (element.cancelDate ? element.cancelDate * 1000 : (element.dischargeDate > 0 ? element.dischargeDate * 1000 : '')) | date: "dd/MM/yyyy hh:mm aa" }}
        </strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{ "EncounterListPage.status" | translate }}
        </th>
    <td mat-cell *matCellDef="let element">
      <span
        class="status-box"
        [ngStyle]="{ 'background-color': element.status.backgroundColor }"
      >
        {{ element.status.text }}
      </span>
    </td>
      </ng-container>

      <ng-container matColumnDef="checkout">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
         {{"EncounterPage.action" | translate}}
        </th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          <mat-icon
          matTooltip="{{ 'adt.receipt' | translate }}"
          data-automation-attribute="icon-receipt"
          (click)="viewBill(element.mrn)"
          >receipt</mat-icon
        >
      
        </td>
      </ng-container>


        <ng-container matColumnDef="viewBill">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.viewBill" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            <mat-icon
              matTooltip="{{ 'adt.receipt' | translate }}"
              data-automation-attribute="icon-receipt"
              (click)="viewBill(element.mrn)"
              >receipt</mat-icon
            >
          </td>
        </ng-container>
        

        <ng-container matColumnDef="mrn">
          <th mat-header-cell *matHeaderCellDef>{{ "adt.mrn" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.mrn }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ipdNo">
          <th mat-header-cell *matHeaderCellDef>
           {{ "adt.ERNo" | translate }}
          </th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.admissionNo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.patientName" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="column-content {{ element.Color }}"
            style="display: flex; align-items: center;"
            [ngClass]="{
              'long-name': (element.patientNameLangBase || element.patientName).length > 50
            }"
            matTooltip="{{ element.patientNameLangBase || element.patientName }},&nbsp;{{ element.vip }},"
          >
            <div>
              <img src="./assets/images/{{ element.patientImage }}" alt="image" /> &nbsp;            
            </div> &nbsp; 
            <div class="name-div"> 
              <span class="name-container"> {{ (element.patientNameLangBase || element.patientName) | NameFormat }}</span> 
            </div>
            <img
              class="user-img"
              [src]="element.isVip ? './assets/images/vip-icon.png' : null"
              *ngIf="element.isVip"
              style="height: 20px; margin-bottom: 5px; float: right;"
            />
          </td>
        </ng-container>
        
        <ng-container matColumnDef="patientGender">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.genderAge" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.PatientGender }}
          </td>
        </ng-container>

        <ng-container matColumnDef="doa">
          <th mat-header-cell *matHeaderCellDef>
             {{ "mrd.visitDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.doa | date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="admittingdept">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.speciality" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.admittingDept }}
          </td>
        </ng-container>

        <ng-container matColumnDef="admittingdoctor">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.doctor" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="column-content {{ element.Color }}"
            [ngClass]="{
              'doctor-long-name': element.admittingDoc.length > 50
            }"
          >
            <div class="name-div">
              <span class="name-container">{{ element.admittingDoc | NameFormat}}</span>
            </div>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="ward">
          <th mat-header-cell *matHeaderCellDef>
           {{ "adt.ERWard" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.ward }}
          </td>
        </ng-container>

        <ng-container matColumnDef="bed">
          <th mat-header-cell *matHeaderCellDef>
         {{ "adt.ERBedNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.bed }}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="los">
          <th mat-header-cell *matHeaderCellDef>{{ "adt.LOS" | translate }}</th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.lengthOfStay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cancelDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.cancelDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.cancelDate * 1000| date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dischargeDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.dischargeDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="{{ element.Color }}">
            {{ element.dischargeDate * 1000| date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ "adt.status" | translate }}
          </th>
          <td
            mat-cell
            [style.font-size.px]="25"
            class="backgroundColor"
            *matCellDef="let element"
            [ngStyle]="{ 'background-color': element.status.backgroundColor} "  
          >
           <b style="font-size: 11px;">{{ element.status.text }}</b> 
        </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;" ></tr>
        <tr
          mat-row
          class="tableRow"
          *matRowDef="let row; let i = index; columns: displayedColumns"
          (click)="rowSelected(row, i)"
          class="mat-row {{ selectedRowNo == i ? 'row-hightlighted' : '' }}"
        ></tr>
      </table>
      <div class="center" *ngIf="dataSource.data.length == 0">
        {{ "adt.noAdmissionFound" | translate }}
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer  position="end"
  #drawer
  mode="over">
  <div class="viewTimeLine">
    <div style=" overflow: auto;">
        <div class="timeline">
            <div class="outer">
                <div *ngFor="let history of internalList">
                    <div class="card">
                        <div class="info">
                            <div style="display: block; font-size: 12px;">
                                <span class="title"> <b>{{ history.status }}</b></span><br>
                                <div style="float: left; text-align: initial;margin-top: 4px; margin-left: 20px;">
                                    <span>Performed by <b>{{ history.createdBy }}</b> on</span><br>
                                    <span style="font-size: 12px;">{{ history.time }}</span><br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center" *ngIf="internalList.length == 0">
               {{ "adt.notFoundData" | translate }}
                </div>
            </div>
        </div>
    </div>
  </div>
</mat-drawer>
</mat-drawer-container>
<div class="divFullWidth" data-automation-attribute="divFooterAction">
  <mat-grid-list cols="15" rowHeight="60px" class="divFooterDetails" style="margin-right: -6.5%;">
    <mat-grid-tile [colspan]="14" class="button-right">
      <div class="mat-grid-tile-content">
        <!-- <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(this.selectedRow, 'pdpaFormnew')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.PDPAForm' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Admission-Form.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
        <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="printReport(this.selectedRow, 'encounterSlip')"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.EncounterSlip' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Patient_Consent.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
      <button
        class="action-btn"
        mat-button
        data-automation-attribute="btn"
        (click)="printReport(this.selectedRow, 'admissionLabel')"
      >
        <img
        class="img action-img"
          [style.width]="'25px'"
          matTooltip="{{ 'adt.label' | translate }}"
          class="img"
          [src]="'./assets/images/adt-icons/Admission-Lebel.png'"
        /></button
      >&nbsp;&nbsp;&nbsp;
      -->
      
      
<!-- Print Menu Button -->

       <button
        class="action-btn"
        mat-button
        data-automation-attribute="btn"
        (click)="redirectToRegistration()"
      > 
        <img
        class="img action-img"
          [style.width]="'25px'"
          matTooltip="{{ 'adt.editPatient' | translate }}"
          class="img"
          [src]="'./assets/images/adt-icons/money-check.png'"
        /></button
      >&nbsp;&nbsp;&nbsp;

<button
  class="action-btn"
  mat-icon-button
  [matMenuTriggerFor]="printMenu"
  matTooltip="Report Print"
>
  <img
    [src]="'./assets/images/adt-icons/Report_print.png'"
    [style.width]="'30px'"
    class="img action-img"
  />
</button>
&nbsp;&nbsp;&nbsp;

<!-- Menu -->
<mat-menu #printMenu="matMenu" class="print-menu">
  <button
    mat-menu-item
    class="menu-item"
    (click)="printReport(selectedRow, 'pdpaFormnew')"
  >
    <img
      src="./assets/images/adt-icons/Admission-Form.png"
      class="menu-icon"
    />
    <span>{{ 'adt.PDPAForm' | translate }}</span>
  </button>

  <button
    mat-menu-item
    class="menu-item"
    (click)="printReport(selectedRow, 'encounterSlip')"
  >
    <img
      src="./assets/images/adt-icons/Patient_Consent.png"
      class="menu-icon"
    />
    <span>{{ 'adt.EncounterSlip' | translate }}</span>
  </button>

  <button
    mat-menu-item
    class="menu-item"
    (click)="printReport(selectedRow, 'admissionLabel')"
  >
    <img
      src="./assets/images/adt-icons/Admission-Lebel.png"
      class="menu-icon"
    />
    <span>{{ 'adt.label' | translate }}</span>
  </button>
  <button mat-menu-item class="menu-item" *ngIf="isLetterOfUndertaking" (click)="printReport(selectedRow, 'LetterOfUndertaking')">
    <img src="./assets/images/adt-icons/Admission-Form.png" class="menu-icon" />
    <span>{{ 'EncounterListPage.LetterOfUndertaking' | translate }}</span>
  </button>
</mat-menu>

      
      <button
        class="action-btn"
        mat-button
        data-automation-attribute="btn"
        (click)="getStatus()"
      >
        <img
        class="img action-img"
          [style.width]="'25px'"
          matTooltip="{{ 'adt.updateStatus' | translate }}"
          class="img"
          [src]="'./assets/images/adt-icons/Status-Update.png'"
        /></button
      >&nbsp;&nbsp;&nbsp;
       
      <button
      class="action-btn"
      mat-button
      data-automation-attribute="btn"
      (click)="uploadDocument()"
    >
      <img
      class="img action-img"
        [style.width]="'25px'"
        matTooltip="{{ 'adt.uploadDocument' | translate }}"
        class="img"
        [src]="'./assets/images/adt-icons/Upload_Document.png'"
      /></button
    >&nbsp;&nbsp;&nbsp;
        <button
        class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="addInternalNotes()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.addInternalNotes' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Admission_Notes.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
        
        <!-- <button
        class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="getPhysicalLocationDetails()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.physicalLocation' | translate }}"
            class="img"
            [src]="'../assets/images/adt-icons/Patient-Physical-Location.png'"
          /></button
        >&nbsp;&nbsp;&nbsp; -->
        <button
          class="action-btn"
            mat-button
            data-automation-attribute="btn"
            (click)="getKinDetails()"
          >
            <img
            class="img action-img"
              [style.width]="'25px'"
              matTooltip="{{ 'adt.kinDetails' | translate }}"
              class="img"
              [src]="'./assets/images/adt-icons/Next-of_Kin.png'"
            /></button
          >&nbsp;&nbsp;&nbsp;
        <button
        class="action-btn"
          mat-button
          data-automation-attribute="button-cancel-dialog"
          *ngIf="isCancelSplRight"
          type="submit"
          style="border-color: red"
          (click)="cancelAdmission()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.CancelVisit' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Cancel-Admission.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;

        <button
        class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="initFinalDischarge()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.checkout' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Patient_Checkout_Physical_Discharge.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
        <button
        class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="getAccountDetails()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'adt.accountDetails' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/patient_payer_details.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
        <button
        class="action-btn"
          mat-button
          data-automation-attribute="btn"
          *ngIf="hasDepositeScreenAccess"
          (click)="getDepositDetails()"
        >
          <img
          class="img action-img"
            [style.width]="'25px'"
            matTooltip="{{ 'billing.deposit' | translate }}"
            class="img"
            [src]="'./assets/images/adt-icons/Patient-Deposit.png'"
          /></button
        >&nbsp;&nbsp;&nbsp;
    
        <button
          class="action-btn"
          mat-button
          data-automation-attribute="btn"
          (click)="viewTimeLine()"
          matTooltip="History"
        ><mat-icon class="custom-icon">history</mat-icon>
          </button
        >
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
<!-- <div class="refresh-block">
  <mat-grid-list cols="10" rowHeight="70px">
    <mat-grid-tile [colspan]="1">
      <mat-icon
        style="margin-right: 74px;"
        class="cyanFont green"
        (click)="refreshSearch()"
        matTooltip="{{ 'adt.refresh' | translate }}"
        data-automation-attribute="icon-cancel"
        >refresh</mat-icon
      >
    </mat-grid-tile>
    <mat-grid-tile [colspan]="3"></mat-grid-tile>
    <mat-grid-tile [colspan]="3"></mat-grid-tile>
    <mat-grid-tile [colspan]="3">
      <div class="div-custom-right">
      <mat-paginator
       
        [length]="totalDataLength"
        [pageSize]="pageSize"
        (page)="getNext($event)"
        #paginator
        [pageSizeOptions]="paginatorOptions"
      >
      </mat-paginator>
    </div>
    </mat-grid-tile>
  </mat-grid-list>
</div> -->

<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>
